import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import api from '@/axios';
import { DELETE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_KEY } from '@/keys';

type DeleteProductionDeclarationCorrectionRequestVariables = {
  commodityOriginId: string;
  correctionRequestId: string;
  materialId: string;
  productionDeclarationId: string;
};

async function deleteProductionDeclarationCorrectionRequest({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  correctionRequestId,
}: DeleteProductionDeclarationCorrectionRequestVariables): Promise<void> {
  await api.delete(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/correction-requests/${correctionRequestId}`,
  );
}

export function useDeleteProductionDeclarationCorrectionRequest(): UseMutationResult<
  void,
  Error,
  DeleteProductionDeclarationCorrectionRequestVariables
> {
  return useMutation({
    mutationKey: DELETE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_KEY,
    mutationFn: deleteProductionDeclarationCorrectionRequest,
  });
}
